// extracted by mini-css-extract-plugin
export default {"button":"Button_button__QPDPh","swap":"Button_swap__Z9zM4","icon":"Button_icon__cuuPG"};